import {kSystemIcons} from "../../constants/icons";

export default function SystemDrawerIcon({onPressed}) {
    // Used in Home desktop and tablet top bars
    // to show menu icon to press to open drawer

    // BUILD
    return (
        <div className={"cursor-pointer flex items-center"}
             onClick={onPressed}>
            <i className={`material-icons text-[32px] text-greyLight9 hover:text-white`}>
                {kSystemIcons.menu}
            </i>
        </div>
    );
}